import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import ButtonLoad from 'react-bootstrap-button-loader';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';

import { closeCCQPunch } from '@actions/timesheet';
import styles from '@styles/punch.module.css';
import PunchCCQForm from '@components/punchCCQ/PunchCCQForm';
import PunchCCQList from '@components/punchCCQ/PunchCCQList'
import AlertAlgo from '@components/controls/AlertSnack';
import * as storage from '@utils/storage';
import * as punchListType from '@scripts/PunchListType';
import * as statusCode from '@scripts/StatusCode';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

export function PunchCCQDay(props) {
    const classes = useStyles();
    const alertRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [openPunchingCCQ, setOpenPunchingCCQ] = useState(false);
    const [isPostCompleted, setIsPostCompleted] = useState(true);
    const [activePunch, setActivePunch] = useState(0);
    const [hasPunch, setHasPunch] = useState(false);
    const [loader, setLoader] = useState(0);
    const [geolocationInfo, setGeolocationInfo] = useState({});

    useEffect(() => {
        loadPage();
    }, []);

    const loadPage = () => {
        setIsActive(false);
        loadGeolocationInfo();
    }

    const loadGeolocationInfo = async () => {
        const geolocation = {};
        geolocation.latitude = 0;
        geolocation.longitude = 0;
        geolocation.isGeolocationAvailable = false;
        geolocation.isGeolocationEnabled = false;
        geolocation.coords = false;

        if (storage.getUseGeolocation()) {
            if ("geolocation" in navigator) {
                geolocation.isGeolocationAvailable = true;

                const successCallback = (position) => {
                    geolocation.latitude = position.coords.latitude;
                    geolocation.longitude = position.coords.longitude;
                    geolocation.isGeolocationEnabled = true;
                    geolocation.coords = true;

                    setGeolocationInfo(geolocation);
                }

                const errorCallback = () => {
                    setGeolocationInfo(geolocation);
                    setIsActive(false);
                }

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback, { timeout: 10000 });
            }
            else {
                setGeolocationInfo(geolocation);
                setIsActive(false);
            }
        }
        else {
            setGeolocationInfo(geolocation);
        }
    }

    const showMessageError = (msg) => {
        alertRef.current.showMessageError(msg);
    }

    const showMessageWarning = (msg) => {
        alertRef.current.showMessageWarning(msg);
    }

    const showMessageSuccess = (msg) => {
        alertRef.current.showMessageSuccess(msg);
    }

    const handleButtonPunchingCCQClick = () => {
        if (!hasPunch || !activePunch || activePunch == 0) {
            setOpenPunchingCCQ(true);
        }
        else if (hasPunch && activePunch) {
            const currentDate = new Date();
            const punchTime = currentDate.getFullYear() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getDate() + " " + currentDate.getHours() + ":" + currentDate.getMinutes();

            closeCCQPunch(punchTime, geolocationInfo.latitude, geolocationInfo.longitude, true)
                .then((response) => {
                    if (response == undefined || response.status == statusCode.STATUS_INTERNALSERVERERROR) {
                        showMessageError(i18next.t('error:generic-error'));
                        setIsPostCompleted(true);
                        setLoading(false);

                        return;
                    }

                    const result = response;

                    if (result.codeReturn == 999) {
                        showMessageWarning(i18next.t('punch:limitTimeClientError'));
                        setLoading(false);
                        setIsPostCompleted(true);
                    }
                    else if (result.codeReturn < 0) {
                        showMessageWarning(result.message);
                        //setSuccess(true);
                        setLoading(false);
                        setIsPostCompleted(true);
                    }
                    else {
                        //setSuccess(true);
                        setLoading(false);
                        setIsPostCompleted(true);
                        showMessageSuccess(result.message);
                        setActivePunch(0);
                        setLoader(loader + 1);
                    }
                }).catch(error => {
                    showMessageWarning('erro');
                });
        }
    };

    const handleClosePunchingCCQ = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenPunchingCCQ(false);
        setLoader(loader + 1);
    }

    const handlePunchState = (activePunch, hasPunch) => {
        setActivePunch(activePunch);
        setHasPunch(hasPunch);
    }

    return (
        <LoadingOverlay className={classes.divLoading} active={isActive} spinner={<BeatLoader />} text={i18next.t('punch:form.loading')}>
            <div id="divPunchRoot" className={styles.punchCcqWrapper}>
                {
                    <div data-id="divPunch" className={styles.divPunchForm}>
                        <PunchCCQList handlePunchState={handlePunchState} punchListType={punchListType.DAY} loader={loader}></PunchCCQList>

                        <ButtonLoad
                            loading={!isPostCompleted}
                            className={styles.punchButton}
                            disabled={loading}
                            onClick={handleButtonPunchingCCQClick}
                            variant="success"
                        >
                            {hasPunch
                                ? !activePunch || activePunch === 0
                                    ? i18next.t('punchCCQ:button.punchNew')
                                    : i18next.t('punchCCQ:button.punchEnd')
                                : i18next.t('punchCCQ:button.punchStart')}
                        </ButtonLoad>

                        {
                            openPunchingCCQ && <Dialog fullScreen open={openPunchingCCQ} onClose={handleClosePunchingCCQ} TransitionComponent={Transition}>
                                <AppBar className={classes.appBar}>
                                    <Toolbar>
                                        <IconButton edge="start" color="inherit" onClick={handleClosePunchingCCQ} aria-label="close">
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" className={classes.title}>
                                            {i18next.t('punchCCQ:button.punch')}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>

                                <div className={styles.rootPunchCCQ}>
                                    <PunchCCQForm onClose={handleClosePunchingCCQ} />
                                </div>
                            </Dialog>
                        }
                    </div>
                }
                <AlertAlgo ref={alertRef} />
            </div>
        </LoadingOverlay>
    )
}

export default withNamespaces(['punch', 'punchCCQ'], { wait: true })(PunchCCQDay);